import "./App.css";
import React, { useEffect } from "react";
import Route from "./Routes";
import Header from "./screens/Header";
import { json, useLocation, useNavigate } from "react-router-dom";
import GlobalLoader from "./components/GlobalLoader";
import { useDispatch, useSelector } from "react-redux";
import { postLogin } from "./store/actions";
import { Dashboard, Login } from "@mui/icons-material";
import LoginScreen from "./screens/LoginScreen";
import Index from "./Routes";
import { clearAllCookies } from "./helper/cookieService";

function App() {
  const pathName = useLocation();
  const navigate = useNavigate();
  // const userData = JSON.parse(localStorage.getItem("userData"));
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  // useEffect(() => {
  //   clearAllCookies();
  // }, []);

  useEffect(() => {
    const cookiesToDelete = [
      'ORG57437',
      '_clck',
      '_fbp',
      '_ga',
      '_ga_DZQO3YW50P',
      '_ga_5F3KWMTESZ',
      '_gac_UA-116554378-1',
      '_gcl_au',
      '_gcl_aw',
      '_gcl_gs'
    ];

    // Delete cookies for localhost
    cookiesToDelete.forEach(cookieName => {
      document.cookie = `${cookieName}=; path=/; domain=localhost; Max-Age=0`;
      document.cookie = `${cookieName}=; path=/; Max-Age=0`;
    });

    // Delete cookies for .bigul.co
    cookiesToDelete.forEach(cookieName => {
      document.cookie = `${cookieName}=; path=/; domain=.bigul.co; Max-Age=0; secure; SameSite=Lax`;
    });
  }, []);
  useEffect(() => {
    if (window.location.hostname !== 'localhost') {
      // Initialize Google Analytics or any other tracking here.
      // Example:
      // ReactGA.initialize('UA-XXXXXXX-X');
      // ReactGA.pageview(window.location.pathname + window.location.search);
    } else {
      console.log("GA disabled on localhost");
    }
  }, []);



  return (
    <React.Fragment>
      <GlobalLoader />
      {userData == null ? "" : (pathName.pathname === "/" || pathName.pathname === "/login") ? null : <Header />
      }
      {userData == null ? <LoginScreen /> : <Index />}
    </React.Fragment >
  );
}

export default App;


//***************************************Under Mntaines code****************************************************** */

// import "./App.css";
// import React, { useEffect } from "react";
// import Header from "./screens/Header";
// import GlobalLoader from "./components/GlobalLoader";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import LoginScreen from "./screens/LoginScreen";
// import Index from "./Routes";

// function App() {
//   const pathName = useLocation();
//   const navigate = useNavigate();
//   const userData = JSON.parse(sessionStorage.getItem("userData"));

//   // ====== Delete cookies ======
//   useEffect(() => {
//     const cookiesToDelete = [
//       'ORG57437', '_clck', '_fbp', '_ga', '_ga_DZQO3YW50P', '_ga_5F3KWMTESZ',
//       '_gac_UA-116554378-1', '_gcl_au', '_gcl_aw', '_gcl_gs'
//     ];

//     cookiesToDelete.forEach(cookieName => {
//       document.cookie = `${cookieName}=; path=/; domain=localhost; Max-Age=0`;
//       document.cookie = `${cookieName}=; path=/; Max-Age=0`;
//       document.cookie = `${cookieName}=; path=/; domain=.bigul.co; Max-Age=0; secure; SameSite=Lax`;
//     });
//   }, []);

//   // ====== Google Analytics (disabled on localhost) ======
//   useEffect(() => {
//     if (window.location.hostname === "localhost") {
//       console.log("GA disabled on localhost");
//     } else {
//       // Initialize GA or Clarity here
//     }
//   }, []);

//   // ====== Maintenance Mode (Toggle here) ======
//   const isMaintenance = true; // 👈 Set true to enable maintenance message

//   if (isMaintenance) {
//     return (
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#0f172a",
//           color: "#ffffff",
//           textAlign: "center",
//           padding: "20px",
//         }}
//       >
//         <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>🔧 Under Maintenance</h1>
//         <p style={{ fontSize: "1.1rem", opacity: 0.9 }}>
//           We're undergoing scheduled maintenance and will be back online shortly. We apologize for the inconvenience.
//         </p>
//       </div>
//     );
//   }

//   // ====== Normal app rendering ======
//   return (
//     <React.Fragment>
//       <GlobalLoader />
//       {userData == null ? "" : (pathName.pathname === "/" || pathName.pathname === "/login") ? null : <Header />}
//       {userData == null ? <LoginScreen /> : <Index />}
//     </React.Fragment>
//   );
// }

// export default App;
